import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const analyticApi = {
  getAnalytics: (params) => {
    return request({
      url: `/analytic/list/${httpBuildQuery(params)}`,
      method: 'GET',
    });
  },
};
